import { connect } from 'react-redux';
import { BrickxLogoDark } from 'src/components/brickxLogo/BrickxLogo';
import { menuOpenSelector } from 'src/store/headerMenuReducer';
import { signupUrl } from 'src/utils/pageUrls';
import {
  toggleMenu as toggleMenuAction,
  closeMenu as closeMenuAction,
} from 'src/store/headerMenuActions';
import Header from 'src/design/components/header/Header';
import MenuItems from 'src/components/header/menu/MenuItems';

const isSignupScreen = (path) =>
  path === signupUrl() || path.startsWith(`${signupUrl()}/`);

const BrickxHeader = ({ menuOpen, toggleMenu, closeMenu, currentPath }) => {
  const shouldShowMenu = !isSignupScreen(currentPath);
  return (
    <Header
      logo={<BrickxLogoDark />}
      mobileMenuOpen={menuOpen}
      onLogoClick={closeMenu}
      onHamburgerIconClick={toggleMenu}
      hidden={!shouldShowMenu}
    >
      <MenuItems />
    </Header>
  );
};

export default connect(menuOpenSelector, {
  toggleMenu: toggleMenuAction,
  closeMenu: closeMenuAction,
})(BrickxHeader);
